export const DATA_TEST_ID_ATTRIBUTE_NAME = 'data-testid';
